const ZoomImage = () => {
  const wysiwyg = document.querySelector('.wysiwyg')
  const modalImage = document.querySelector('.modal-image')
  if (!wysiwyg || !modalImage) return

  const closeModalBtn = modalImage.querySelector('.modal-image__close')
  const inner = modalImage.querySelector('.modal-image__inner')

  const buildImageElement = figureEl => {
    const figure = document.createElement('figure')
    const caption = figureEl.querySelector('figcaption')
    const modalSrc = figureEl.dataset.modalSrc || figureEl.querySelector('img').src
    let figureContent = `<img src="${modalSrc}" />`
    if (caption) {
      figureContent += `<figcaption>${caption.textContent}</figcaption>`
    }
    figure.innerHTML = figureContent
    inner.appendChild(figure)
  }

  const cleanImageElement = () => {
    inner.innerHTML = ''
  }

  const isMobile = () => window.innerWidth < 1024

  const openImageModal = e => {
    if (isMobile()) return
    const parent = e.currentTarget.parentNode
    buildImageElement(parent)
    modalImage.classList.add('show')
    document.documentElement.classList.add('modal-opened')
  }

  const closeImageModal = () => {
    cleanImageElement()
    modalImage.classList.remove('show')
    document.documentElement.classList.remove('modal-opened')
    modalImage.removeEventListener('click', handleClickOutside)
  }

  const handleClickOutside = e => {
    if (e.target !== modalImage) return
    closeImageModal()
  }
  
  const images = wysiwyg.querySelectorAll('.wp-block-image img')
  images.forEach(image => {
    image.addEventListener('click', openImageModal)
  });

  closeModalBtn.addEventListener('click', closeImageModal)
  modalImage.addEventListener('click', handleClickOutside)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeImageModal()
    }
  })
}

export default ZoomImage



// WEBPACK FOOTER //
// ./scripts/components/ZoomImage.js